import React, { useState, useEffect } from 'react';
import './EditorStyles.css';

const MessagesEditor = () => {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadMessages();
  }, []);

  const loadMessages = async () => {
    try {
      const token = localStorage.getItem('dashboard_token');
      const response = await fetch(`${process.env.REACT_APP_API_URL || 'https://server.acpca.net/api'}/contact/messages`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      const data = await response.json();
      if (data.success) {
        setMessages(data.data);
      }
    } catch (error) {
      console.error('Error loading messages:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleMarkAsRead = async (id) => {
    try {
      const token = localStorage.getItem('dashboard_token');
      const response = await fetch(`${process.env.REACT_APP_API_URL || 'https://server.acpca.net/api'}/contact/messages/${id}/read`, {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      const data = await response.json();
      if (data.success) {
        loadMessages();
      }
    } catch (error) {
      console.error('Mark as read error:', error);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('هل أنت متأكد من حذف هذه الرسالة؟')) return;

    try {
      const token = localStorage.getItem('dashboard_token');
      const response = await fetch(`${process.env.REACT_APP_API_URL || 'https://server.acpca.net/api'}/contact/messages/${id}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      const data = await response.json();
      if (data.success) {
        loadMessages();
      }
    } catch (error) {
      console.error('Delete error:', error);
    }
  };

  if (loading) {
    return <div className="editor-loading">جاري التحميل...</div>;
  }

  return (
    <div className="editor-container">
      <div className="editor-header">
        <h2>رسائل التواصل</h2>
      </div>

      <div className="editor-items-list">
        {messages.length === 0 ? (
          <p style={{ textAlign: 'center', padding: '40px', color: '#666' }}>لا توجد رسائل</p>
        ) : (
          messages.map((msg) => (
          <div key={msg.id} className="editor-item-card">
            <div className="editor-item-content">
              <h4>{msg.first_name} {msg.last_name}</h4>
              <p><strong>البريد الإلكتروني:</strong> {msg.email}</p>
              <p><strong>الهاتف:</strong> {msg.phone || 'غير محدد'}</p>
              <p><strong>الرسالة:</strong> {msg.message}</p>
              <p><small>{new Date(msg.created_at).toLocaleString('ar-SA')}</small></p>
            </div>
            <div className="editor-item-actions">
              {!msg.is_read && (
                <button className="editor-btn-sm editor-btn-edit" onClick={() => handleMarkAsRead(msg.id)}>
                  تحديد كمقروء
                </button>
              )}
              <button className="editor-btn-sm editor-btn-delete" onClick={() => handleDelete(msg.id)}>
                حذف
              </button>
            </div>
          </div>
          ))
        )}
      </div>
    </div>
  );
};

export default MessagesEditor;

